// src/hooks/useAppLinks.js
import { useMemo } from "react";

export function useAppLinks() {
  const userDevice = typeof window !== "undefined" ? (navigator.userAgent || window.opera) : "";
  const isIOS = /iPad|iPhone|iPod/.test(userDevice) && !window.MSStream;

  const evinAkli = isIOS
    ? "https://apps.apple.com/tr/app/evin-aklı/id966916050"
    : "https://play.google.com/store/apps/details?id=com.smarthome.core.main&hl=tr";

  const vfit = isIOS
    ? "https://apps.apple.com/tr/app/vfit/id1491459940"
    : "https://play.google.com/store/apps/details?id=com.vestel.vfitplus";

  return useMemo(() => ({ evinAkli, vfit }), [evinAkli, vfit]);
}
